import type { Template } from '@/types/api';

interface TemplatePreviewProps {
  template: Template;
  className?: string;
}

export function TemplatePreview({ template, className = '' }: TemplatePreviewProps) {
  if (template.template_preview) {
    return (
      <div className={`aspectly:relative aspectly:h-full aspectly:w-full aspectly:overflow-hidden aspectly:bg-surface-container ${className}`}>
        <img
          src={template.template_preview}
          alt={`${template.name} preview`}
          className="aspectly:w-full aspectly:h-full aspectly:object-cover aspectly:rounded-xs"
        />
      </div>
    );
  }

  return (
    <div className={`aspectly:relative aspectly:h-full aspectly:w-full aspectly:overflow-hidden aspectly:bg-surface-container aspectly:flex aspectly:items-center aspectly:justify-center ${className}`}>
      <span className="aspectly:text-sm aspectly:font-medium aspectly:text-on-surface-variant">
        No preview available
      </span>
    </div>
  );
}
